import { render, staticRenderFns } from "./CreateExpenseModal.vue?vue&type=template&id=58e35be0&"
import script from "./CreateExpenseModal.vue?vue&type=script&lang=js&"
export * from "./CreateExpenseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports